import { useSyncExternalStore } from "react";

/** Tailwind `sm` — shared by primitives drawer and SMB action card drawers. */
export const DRAWER_SM_UP_MEDIA_QUERY = "(min-width: 640px)";

function subscribeDrawerSmUp(onStoreChange: () => void) {
  if (typeof window === "undefined") return () => {};
  const mq = window.matchMedia(DRAWER_SM_UP_MEDIA_QUERY);
  mq.addEventListener("change", onStoreChange);
  return () => mq.removeEventListener("change", onStoreChange);
}

function getDrawerSmUpSnapshot() {
  return typeof window !== "undefined"
    ? window.matchMedia(DRAWER_SM_UP_MEDIA_QUERY).matches
    : false;
}

function getDrawerSmUpServerSnapshot() {
  return false;
}

/**
 * True at the `sm` breakpoint and up: drawers use a fixed right-hand panel
 * instead of a bottom sheet (see `Drawer` primitive and `ActionCard` drawer).
 */
export function useDrawerSmUp(): boolean {
  return useSyncExternalStore(
    subscribeDrawerSmUp,
    getDrawerSmUpSnapshot,
    getDrawerSmUpServerSnapshot,
  );
}
